import React, { useState } from 'react';
import styles from './LoginForm.module.scss';

const LoginForm = ({ setPasswordCorrect }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  const handleLogin = (event) => {
    event.preventDefault();
    if (password === process.env.REACT_APP_PASSWORD) {
      setPasswordCorrect(true);
    } else {
      setError(true);
      setPassword('');
    }
  };

  return (
    <div className={styles.page}>
      <form onSubmit={handleLogin} className={styles.card}>
        <div className={styles.header}>
          <h1 className={styles.title}>Mood Palace</h1>
          <p className={styles.description}>Enter the password to manage uploads.</p>
        </div>

        <div className={styles.field}>
          <label htmlFor='password' className={styles.label}>
            Password
          </label>
          <input
            id='password'
            type='password'
            autoComplete='current-password'
            autoFocus
            value={password}
            onChange={(e) => {
              setError(false);
              setPassword(e.target.value);
            }}
            className={[styles.input, error && styles.inputError].filter(Boolean).join(' ')}
            aria-invalid={error}
            aria-describedby={error ? 'password-error' : undefined}
            required
          />
          {error && (
            <p id='password-error' className={styles.error}>
              Incorrect password. Try again.
            </p>
          )}
        </div>

        <button type='submit' className={styles.button}>
          Continue
        </button>
      </form>
    </div>
  );
};

export default LoginForm;
